const ID = /^[\w-]{11}$/;

/**
 * The video id in a YouTube link: watch?v=, youtu.be/, shorts/, embed/, live/, music.youtube.com,
 * or a bare 11-character id. Null when it isn't one. (Same rules as the API server.)
 */
export function youtubeId(input: string): string | null {
  const text = input.trim();
  if (ID.test(text)) return text;
  let url: URL;
  try {
    url = new URL(/^https?:\/\//i.test(text) ? text : `https://${text}`);
  } catch {
    return null;
  }
  const host = url.hostname.replace(/^(www|m|music)\./, '');
  let id: string | null = null;
  if (host === 'youtu.be') id = url.pathname.slice(1).split('/')[0] ?? null;
  else if (host === 'youtube.com' || host === 'youtube-nocookie.com') {
    id = url.searchParams.get('v');
    const path = /^\/(?:shorts|embed|live|v)\/([^/?#]+)/.exec(url.pathname);
    if (!id && path) id = path[1] ?? null;
  }
  return id && ID.test(id) ? id : null;
}
